import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { PlayCircleIcon} from "@heroicons/react/solid";
import { PlayCircleIcon } from "@heroicons/react/16/solid";
import { fetchPublicVideos } from "../../features/admin/MediaSlice";
import { Link } from "react-router-dom";
import { HomeIcon } from "@heroicons/react/24/outline";

//
const VideoGallery = () => {
  // Lấy danh sách video từ Redux store
  let dispatch = useDispatch();
  const { publicMedias: medias } = useSelector((state) => state.medias);
  useEffect(() => {
    dispatch(fetchPublicVideos());
  }, [dispatch]);
  // Xử lý khi click vào video
  const handleVideoClick = (videoId) => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank");
  };

  const getVideoId = (link) => {
    if (!link) return "";
    if (link.includes("embed/")) {
      return link.split("embed/")[1];
    }
    if (link.includes("watch?v=")) {
      return link.split("watch?v=")[1];
    }
    return link;
  };

  return (
    <div className="container mx-auto">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 flex-wrap">
          <li className="inline-flex items-center">
            <Link to="/" className="inline-flex items-center hover:text-blue-600 font-medium">
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium">Video</span>
            </div>
          </li>
        </ol>
      </nav>

      {!medias || medias.length === 0 ? (
        <div className="alert alert-info shadow-lg">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="stroke-current flex-shrink-0 w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <span>Không có video nào được tìm thấy.</span>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {medias.map((post, index) => (
            <div
              key={index}
              className="card bg-base-100 shadow-xl hover:shadow-2xl transition-all"
            >
              <figure
                // className="p-4 shadow-md rounded-lg bg-base-100 hover:bg-gray-200 transition duration-200"
                className="relative aspect-video cursor-pointer group"
                onClick={() => handleVideoClick(getVideoId(post.url))}
              >
                <div className="w-full h-full">
                  <iframe
                    src={post?.url?.replace("watch?v=", "embed/")}
                    title={post.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                    loading="lazy"
                    style={{
                      // opacity: isLoading ? 0 : 1,
                      transition: "opacity 0.3s ease",
                    }}
                  ></iframe>
                </div>

                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all">
                  <PlayCircleIcon className="w-12 h-12 text-white" />
                </div>
              </figure>
              <div className="card-body">
                <h2 className="card-title line-clamp-2">{post.title}</h2>
                {post.description && (
                  <p className="text-sm text-gray-600 line-clamp-3">
                    {post.description}
                  </p>
                )}
                {/* <div className="card-actions justify-end mt-2">
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleVideoClick(getVideoId(post.url))}
                  >
                    Xem trên YouTube
                    <PlayCircleIcon className="w-4 h-4 ml-1" />
                  </button>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoGallery;
